import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenRuler } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@material-ui/core';

import { Style } from './PenWidthButton.css'

const PenWidthButton = ({ onSelectWidth }) => {
  const [isPenWidthOpen, setIsPenWidthOpen] = useState(false);
  const [selectedWidth, setSelectedWidth] = useState(3);
  const penWidthRef = useRef(null); // Reference to the pen-width div

  const handleWidthSelect = (width, event) => {
    setSelectedWidth(width);
    onSelectWidth(width);
    setIsPenWidthOpen(false);
    event.stopPropagation();

  };

  // Close the pen-width if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      /* Check if the reference is not null && doesn't contain the click */
      if (penWidthRef.current && !penWidthRef.current.contains(event.target)) {
        setIsPenWidthOpen(false);
      }
    };
    
    // Add event listener to detect clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [penWidthRef]);

  return (
    <div className="pen-width-button">
    <IconButton onClick={() => setIsPenWidthOpen(!isPenWidthOpen)} title="Pen Size">
        <FontAwesomeIcon icon={faPenRuler} />
    </IconButton>

      {isPenWidthOpen && (
        <div className="pen-width-button__dropdown" ref={penWidthRef}>
          <div className="pen-width-button__label">Pen Size</div>
          <div className="pen-width-button__widths">
            <div
              className={`pen-width-button__width pen-width-button__width--1 ${selectedWidth === 1 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(1, e)}
              title="Small"
            ></div>
            <div
              className={`pen-width-button__width pen-width-button__width--3 ${selectedWidth === 3 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(3, e)}
              title="Medium"
            ></div>
            <div
              className={`pen-width-button__width pen-width-button__width--5 ${selectedWidth === 5 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(5, e)}
              title="Large"
            ></div>
            <div
              className={`pen-width-button__width pen-width-button__width--7 ${selectedWidth === 7 ? 'active' : ''}`}
              onClick={(e) => handleWidthSelect(7, e)}
              title="Extra Large"
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PenWidthButton;
